import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const UpwardTreeIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <circle
        cx='8.5'
        cy='1.5'
        r='1.5'
        transform='rotate(90 8.5 1.5)'
        fill='currentColor'
      />
      <path
        d='M8.5 8.5L14.5 8.5L14.5 14.5M8.5 8.5L8.5 1.5M8.5 8.5L1.5 8.5L1.5 14.5'
        stroke='currentColor'
      />
      <path d='M5.5 14.5L8.5 8.5L10.5 14.5' stroke='currentColor' />
      <circle
        cx='14.5'
        cy='8.5'
        r='1.5'
        transform='rotate(90 14.5 8.5)'
        fill='currentColor'
      />
      <circle
        cx='14.5'
        cy='14.5'
        r='1.5'
        transform='rotate(90 14.5 14.5)'
        fill='currentColor'
      />
      <circle
        cx='8.5'
        cy='8.5'
        r='1.5'
        transform='rotate(90 8.5 8.5)'
        fill='currentColor'
      />
      <circle
        cx='5.5'
        cy='14.5'
        r='1.5'
        transform='rotate(90 5.5 14.5)'
        fill='currentColor'
      />
      <circle
        cx='10.5'
        cy='14.5'
        r='1.5'
        transform='rotate(90 10.5 14.5)'
        fill='currentColor'
      />
      <circle
        cx='1.5'
        cy='8.5'
        r='1.5'
        transform='rotate(90 1.5 8.5)'
        fill='currentColor'
      />
      <circle
        cx='1.5'
        cy='14.5'
        r='1.5'
        transform='rotate(90 1.5 14.5)'
        fill='currentColor'
      />
    </SvgWrapper>
  ),
);

UpwardTreeIcon.displayName = 'UpwardTreeIcon';
